import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InventoryService } from '../_service/inventory.service';
import Swal from 'sweetalert2';
import { FormsModule } from '@angular/forms';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-inventory',
  standalone: true,
  imports: [RouterModule, CommonModule, NgbModule, FormsModule],
  templateUrl: './inventory.component.html',
  styleUrl: './inventory.component.scss'
})
export class InventoryComponent implements OnInit {
  invetorySrvs = inject(InventoryService)
  router = inject(Router)
  inventories: any = signal('');
  EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

  // Math for template
  Math = Math;

  // Pagination and data properties
  page = 1
  size = 0
  pageSize = 1
  page2 = 10
  categories: any;
  status: any;
  selectedCategory: string = '';
  selectedStatus: string = '';
  search: any;
  category: any;
  listcategories: any;
  data: any[] = [];

  // Loading States - Comprehensive coverage
  isLoading = signal(false);
  isLoadingInventories = signal(false);
  isLoadingCategories = signal(false);
  isFilteringCategory = signal(false);
  isFilteringStatus = signal(false);
  isTogglingStatus = signal(false);
  isExporting = signal(false);
  searchLoading = signal(false);
  isRefreshing = signal(false);
  isClearingFilters = signal(false);
  isNavigating = signal(false);
  isDeleting = signal(false);
  actionInProgress = signal(false);

  ngOnInit(): void {
    this.listInventory()
    this.listCategory()
  }

  listInventory() {
    this.isLoadingInventories.set(true);
    this.invetorySrvs.listInventories(this.page).subscribe({
      next: (res: any) => {
        console.log(res)
        this.inventories.set(res.data)
        this.data = []; // Clear existing data
        for (let inv of this.inventories()) {
          const data = { 'name': inv.name, 'category': inv.category.name, 'quantity': inv.quantity, 'cost price': inv.cost_price, 'selling price': inv?.selling_price }
          this.data.push(data)
        }
        console.log('data', this.data)
        const meta = res.meta
        this.size = meta.total
        this.pageSize = meta.per_page
      },
      error: (err: any) => {
        console.log(err);
        Swal.fire({
          title: 'Error!',
          text: 'Failed to load inventories. Please try again.',
          icon: 'error',
          confirmButtonColor: '#00a859'
        });
      },
      complete: () => {
        this.isLoadingInventories.set(false);
        this.isRefreshing.set(false);
      }
    })
  }
  capitalizeFirstLetter(sentence: string) {
    if (!sentence) return sentence; // Check if the sentence is empty or undefined
    return sentence.charAt(0).toUpperCase() + sentence.slice(1);
  }

  getTotalPages(): number {
    return Math.ceil(this.size / this.pageSize);
  }
  // Debounce timer for search
  private searchDebounce: any;

  onSearch() {
    if (!this.search?.trim()) {
      this.listInventory();
      return;
    }

    // Clear previous timeout
    if (this.searchDebounce) {
      clearTimeout(this.searchDebounce);
    }

    // Debounce search by 600ms
    this.searchDebounce = setTimeout(() => {
      this.searchLoading.set(true);
      this.invetorySrvs.listInventories(this.page, this.search, this.category, this.status).subscribe({
        next: (res: any) => {
          this.inventories.set(res.data);
          const meta = res.meta;
          this.size = meta.total;
          this.pageSize = meta.per_page;
        },
        error: (err: any) => {
          console.log(err);
          Swal.fire({
            title: 'Search Failed!',
            text: 'Unable to search inventories. Please try again.',
            icon: 'error',
            confirmButtonColor: '#00a859'
          });
        },
        complete: () => {
          this.searchLoading.set(false);
        }
      });
    }, 500);
  }
  CatFilter(name:any,filter: any) {
    this.isFilteringCategory.set(true);
    this.category = filter
    this.selectedCategory = name;
    this.invetorySrvs.listInventories(this.page, this.search, this.category, this.status).subscribe({
      next: (res: any) => {
        this.inventories.set(res.data)
        const meta = res.meta
        this.size = meta.total
        this.pageSize = meta.per_page
        console.log('Users', res)
      },
      error: (err: any) => {
        console.log(err)
        Swal.fire('Error', 'Category filter failed', 'error');
      },
      complete: () => {
        this.isFilteringCategory.set(false);
      }
    })
  }

  listCategory() {
    this.isLoadingCategories.set(true);
    this.invetorySrvs.listCategories().subscribe({
      next: (res: any) => {
        console.log(res)
        this.listcategories = res
      },
      error: (err: any) => {
        console.log(err);
        Swal.fire('Error', 'Failed to load categories', 'error');
      },
      complete: () => {
        this.isLoadingCategories.set(false);
      }
    })
  }
  statuusFilter(status: any) {
    this.isFilteringStatus.set(true);
    this.selectedStatus = status;
    this.status = status
    this.invetorySrvs.listInventories(this.page, this.search, this.category, this.status).subscribe({
      next: (res: any) => {
        this.inventories.set(res.data)
        const meta = res.meta
        this.size = meta.total
        this.pageSize = meta.per_page
        // console.log('Users', res)
      },
      error: (err: any) => {
        console.log(err)
        Swal.fire('Error', 'Status filter failed', 'error');
      },
      complete: () => {
        this.isFilteringStatus.set(false);
      }
    })
  }

  clearFilter() {
    this.isClearingFilters.set(true);
    this.page = 1
    this.search = null
    this.status = null
    this.category = null
    this.selectedCategory = '';
    this.selectedStatus = '';

    // Small delay for better UX
    setTimeout(() => {
      this.listInventory();
      this.isClearingFilters.set(false);
    }, 300);
  }


  refresh(event: any) {
    this.page = event
    this.isRefreshing.set(true);
    this.listInventory()
  }

  refreshInventory() {
    this.isRefreshing.set(true);
    this.listInventory();
  }

  edit(id: any) {
    this.isNavigating.set(true);
    setTimeout(() => {
      this.router.navigateByUrl(`/admin/inventory/edit_inventory/${id}`)
      this.isNavigating.set(false);
    }, 200);
  }

  create() {
    this.isNavigating.set(true);
    setTimeout(() => {
      this.router.navigateByUrl('/admin/inventory/create_inventory')
      this.isNavigating.set(false);
    }, 200);
  }
  enable(data: any) {
    this.actionInProgress.set(true);
    this.isTogglingStatus.set(true);

    const action = data.disabled ? 'enable' : 'disable';
    const actionText = data.disabled ? 'enabled' : 'disabled';

    this.invetorySrvs.enable_disableInv(data.id).subscribe({
      next: (res: any) => {
        Swal.fire({
          title: 'Success!',
          text: `Item has been ${actionText} successfully.`,
          icon: 'success',
          confirmButtonColor: '#00a859',
          timer: 2000,
          showConfirmButton: false
        });
      },
      error: (err: any) => {
        Swal.fire({
          title: 'Failed!',
          text: err.error?.error || `Failed to ${action} item. Please try again.`,
          icon: 'error',
          confirmButtonColor: '#00a859'
        });
      },
      complete: () => {
        this.isTogglingStatus.set(false);
        this.actionInProgress.set(false);
        this.listInventory()
      }
    })
  }

  exportToExcel(): void {
    this.isExporting.set(true);

    try {
      // Convert the data to a worksheet
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.data);

      // Create a new workbook and append the worksheet
      const workbook: XLSX.WorkBook = {
        Sheets: { 'data': worksheet },
        SheetNames: ['data']
      };

      // Generate the Excel file and save it
      const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, `inventories_${new Date().toISOString().split('T')[0]}`);

      Swal.fire({
        title: 'Export Successful!',
        text: 'Inventory data has been exported successfully.',
        icon: 'success',
        confirmButtonColor: '#00a859',
        timer: 2000,
        showConfirmButton: false
      });
    } catch (error) {
      Swal.fire({
        title: 'Export Failed!',
        text: 'Failed to export data. Please try again.',
        icon: 'error',
        confirmButtonColor: '#00a859'
      });
    } finally {
      this.isExporting.set(false);
    }
  }

  // Helper function to save the file
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: this.EXCEL_TYPE });
    saveAs(data, `${fileName}.xlsx`);
  }

  view(inv: any) {
    // if (inv.length > 1) {
    //   for (let logs of inv){
    //     window.open(inv[0].receipt, '_blank')
    //   }
    // } else{
    //   window.open(inv[0].receipt, '_blank')
    // }

    for (let logs of inv) {
      window.open(logs.receipt, '_blank')
    }

  }
  viewLogs(inv: any) {
    console.log(inv);
    this.isNavigating.set(true);
    setTimeout(() => {
      this.router.navigateByUrl(`/admin/inventory/inventory_stock/${inv.id}`)
      this.isNavigating.set(false);
    }, 200);
  }

  // Helper method to check if any action is in progress
  isAnyActionInProgress(): boolean {
    return this.isLoadingInventories() ||
           this.isFilteringCategory() ||
           this.isFilteringStatus() ||
           this.isTogglingStatus() ||
           this.isExporting() ||
           this.searchLoading() ||
           this.isRefreshing() ||
           this.isClearingFilters() ||
           this.isNavigating() ||
           this.actionInProgress();
  }
}


